/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useContext } from "react";
import Compass from "@arcgis/core/widgets/Compass";

import "./CompassWidget.scss";
import { MapContext } from "../../context/MapContext";

function CompassWidget() {
  const [mapObject] = useContext(MapContext);

  useEffect(() => {
    if (mapObject?.view) {
     
      var compass = new Compass({
        view: mapObject?.view
      });
      
      // adds the compass to the top left corner of the MapView
      mapObject?.view.ui.add(compass, "top-left")
    }
  }, [mapObject?.view]);

  return (
    <>
    </>
  );
}

export default CompassWidget;
